import gql from 'graphql-tag';
import { parseToMutationRequest } from '../../../utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, ['index']);
  const modifyUom = `modifyUom(input: ${dataModify})`;
  return gql`
  mutation {
    ${modifyUom} {
      id
    }
  }
`;
};
